import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_USERS } from "../../../service/ApolloClient/ApolloQueries";
import { Link } from "react-router-dom";
import { MUTATION_REMOVE_USER } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { confirmAlert } from "react-confirm-alert";
import NumberFormat from "react-number-format";
import { numberFormatter } from "../../../utility/Number/numberFormatter"; // Import

class PersonList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return <Link to={`/person/edit/${rowData.id}`}>{rowData.id}</Link>;
          },
        },
        { title: "نام و نام خانوادگی", field: "fullname" },

        {
          title: "معرف",
          field: "recommender_fullname",
          render: (rowData) =>
            rowData.recommender_id ? (
              <a href={`/profile/${rowData.recommender_id}`}>
                {rowData.recommender_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "ضامن",
          field: "guarantor_fullname",
          render: (rowData) =>
            rowData.guarantor_id ? (
              <a href={`/profile/${rowData.guarantor_id}`}>
                {rowData.guarantor_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "مانده",
          field: "remain",
          render: (rowData) => (
            <span style={{ color: this.colorRemain(rowData.remain) }}>
              <NumberFormat
                value={rowData.remain}
                thousandSeparator={true}
                displayType={"text"}
              />
            </span>
          ),
          pdfRender: (rowData) => (numberFormatter(rowData.remain))
        },
        { title: "شماره ملی", field: "id_number" },
        {
          title: "شماره تلفن",
          field: "phone",
          render: (rowData) => {
            return rowData.phone
              ? Array.isArray(JSON.parse(rowData.phone))
                ? JSON.parse(rowData.phone).join(" , ")
                : ""
              : "";
          },
          pdfRender: (rowData) => {
            return rowData.phone
              ? Array.isArray(JSON.parse(rowData.phone))
                ? JSON.parse(rowData.phone).join(", ")
                : ""
              : "";
          }
        },
        {
          title: "شماره موبایل",
          field: "mobile",
          render: (rowData) => {
            return rowData.mobile
              ? Array.isArray(JSON.parse(rowData.mobile))
                ? JSON.parse(rowData.mobile).join(" , ")
                : ""
              : "";
          },
          pdfRender: (rowData) => {
            return rowData.mobile
              ? Array.isArray(JSON.parse(rowData.mobile))
                ? JSON.parse(rowData.mobile).join(", ")
                : ""
              : "";
          },
        },
        { title: "پاس/برگشتی/سایر", field: "cheque_num", sorting: false,
        render: (rowData) => (
          <div style={{ direction: 'ltr' }}>{rowData.cheque_num}</div>
        )},
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  colorRemain(remain) {
    if (remain < 0) return "#ff0000";
    else return "#006400";
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_USERS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy:
            this.props.defaultSort != null
              ? this.props.defaultSort
              : query.orderBy
                ? query.orderBy.field
                : null,
          orderDirection:
            this.props.defaultSort != null ? "desc" : query.orderDirection,
          is_admin: this.props.isAdmin ? true : false,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.users.data,
          page: query.page,
          totalCount: data.users.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_USER,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeUser;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "اشخاص " + (this.props.name ? this.props.name : "");
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        editLink={this.props.isAdmin ? "/person/admin/edit/" : "/person/edit/"}
        handleRemove={this.handleRemove}
        needExport={true}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default PersonList;
